import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory.import-users', {
        url: '/import-users',
        views: {
            '@company.user-directories': 'companyUserDirectoriesDirectoryGroupsDirectoryImportUsers'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/import-users/import-users.state.js